export const RESPONSE_MESSAGES = {
  FETCH_MENU_ERROR: 'An error occurred while fetching the menu data',
  FETCH_MENU_FAILED: 'Failed to fetch menu data',
  FETCH_PRODUCT_ERROR: 'An error occurred while fetching the product details',
  FETCH_PRODUCT_FAILED: 'Failed to fetch the product details',
  UNEXPECTED_ERROR: 'An unexpected error occurred',
  PRODUCT_NOT_FOUND: 'The product you are looking for could not be found',
  INVALID_INPUT: 'The input provided is invalid',
  NETWORK_ERROR: 'Network error, please check your internet connection',
  UNAUTHORIZED_ACCESS: 'You do not have permission to access this resource',
  FORBIDDEN: 'You do not have permission to perform this action',
  SUCCESS: 'Operation completed successfully',
  UPDATED_SUCCESS: 'Data updated successfully',
  DELETED_SUCCESS: 'Item deleted successfully',
  CREATED_SUCCESS: 'New item created successfully',
  LOGIN_FAILED: 'Login failed, please check your credentials',
  LOGIN_SUCCESS: 'Successfully logged in',
  REGISTRATION_SUCCESS: 'Registration completed successfully',
  REGISTRATION_FAILED: 'Registration failed, please try again later',
  PASSWORD_RESET_LINK_SENT: 'Password reset link has been sent to your email',
  PASSWORD_RESET_FAILED: 'Failed to reset the password, please try again later',
  INVALID_SESSION: 'Your session has expired. Please log in again',
  SERVER_ERROR: 'Internal server error, please try again later',
  FORGOT_PASSWORD_SUCCESS: 'Password reset link sent to your email!',
  FORGOT_PASSWORD_FAILED: 'Forgot password Failed',
  LOGOUT_SUCCESS: 'Success full logout',
  INVALID_TOKEN: 'The token is invalid or expired',
  EMAIL_ALREADY_IN_USE: 'The email address is already registered',
  USER_NOT_FOUND: 'User not found, please register first',
  ACCESS_DENIED: 'You do not have the required permissions to access this resource',
  API_RATE_LIMIT_EXCEEDED: 'Too many requests. Please try again later',
  SESSION_EXPIRED: 'Your session has expired. Please log in again',
  INSUFFICIENT_FUNDS: 'You have insufficient funds to complete this action',
  ORDER_NOT_FOUND: 'The order you are looking for does not exist',
  PRODUCT_OUT_OF_STOCK: 'The product is currently out of stock',
  OPERATION_FAILED: 'The operation could not be completed, please try again later',
  ORDER_PLACED: 'Order placed successfully.',
  ORDER_FAILED: 'Something went wrong while placing the order',
  PAYMENT_REDIRECTING: 'Redirecting to payment...',
  PAYMENT_FAILED: 'Failed to get payment.',
  SELECT_SHIPPING_OPTION: 'Please select a shipping option',
  SELECT_PAYMENT_METHOD: 'Please select a payment method',
  PASSWORD_REQUIREMENTS:
    'Password must be at least 10 characters long, contain uppercase, lowercase, a number, and a special character',
  PASSWORD_MISMATCH: 'Passwords must match',
  PASSWORD_REQUIRED: 'Password is required',
  TOKEN_NOT_FOUND: 'Token not found',
  USER_ID_NOT_FOUND: 'User ID not found. Please try again.',
  PASSWORD_RESET_SUCCESS: 'Password reset successfully.',
  VALIDATING_TOKEN: 'Validating token...',
  WISHLIST: {
    READ: {
      SUCCESS: 'Wishlist successfully retrieved',
      ERROR: 'Wishlist cannot be retrieved',
    },
    ADD: {
      SUCCESS: 'Product successfully added to the wishlist',
      ERROR: 'Product cannot be added to the wishlist',
    },
    REMOVE: {
      SUCCESS: 'Product successfully removed from the wishlist',
      ERROR: 'Product cannot be removed from the wishlist',
    },
  },
  CART: {
    READ: {
      SUCCESS: 'Cart successfully retrieved',
      ERROR: 'Cart cannot be retrieved',
    },
    ADD: {
      SUCCESS: 'Product successfully added to the cart',
      ERROR: 'Product cannot be added to the cart',
    },
    REMOVE: {
      SUCCESS: 'Product successfully removed from the cart',
      ERROR: 'Product cannot be removed from the cart',
    },
    COUPON: {
      REMOVE: {
        SUCCESS: 'Coupon removed successfully',
        ERROR: 'Coupon cannot be removed',
      },
    },
    VALIDATION: {
      PRODUCT_OUT_OF_STOCK: 'Product out of stock',
    },
  },
  PRODUCT_INFO: {
    COLOR_VARIANT: 'Please select a color variant',
    SIZE_VARIANT: 'Please select a size',
  },
  BILLING_ADDRESS: {
    READ: {
      SUCCESS: 'Billing address retrieved successfully.',
      ERROR: 'Unable to retrieve billing address. Please try again.',
    },
    ADD: {
      SUCCESS: 'Billing address added successfully.',
      ERROR: 'Failed to add billing address. Please try again.',
    },
    UPDATE: {
      SUCCESS: 'Billing address updated successfully.',
      ERROR: 'Failed to update billing address. Please try again.',
    },
    REMOVE: {
      SUCCESS: 'Billing address removed successfully.',
      ERROR: 'Failed to remove billing address. Please try again.',
    },
  },
  PROFILE: {
    READ: {
      SUCCESS: 'Profile information loaded successfully.',
      ERROR: 'Failed to load profile information. Please try again.',
    },
    ADD: {
      SUCCESS: 'Profile created successfully.',
      ERROR: 'Failed to create profile. Please try again.',
    },
    UPDATE: {
      SUCCESS: 'Profile updated successfully.',
      ERROR: 'Failed to update profile. Please try again.',
    },
    REMOVE: {
      SUCCESS: 'Profile removed successfully.',
      ERROR: 'Failed to remove profile. Please try again.',
    },
  },
  CONTACT: {
    CREATE: {
      SUCCESS: 'Your message has been submited successfully! ',
      ERROR: ' Message can not be sent successfully',
    },
  },
};
